// Internet Explorer polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import axios from 'axios'
import { datadogRum } from '@datadog/browser-rum'
import { render } from 'react-dom'
import React, { StrictMode } from 'react'
import Root from './Root'
import Title from './HtmlTitle'
import { Provider as StoreProvider } from 'react-redux'
import smoothscroll from 'smoothscroll-polyfill'
import 'intersection-observer'
import 'url-search-params-polyfill'
import 'font-awesome/css/font-awesome.css'
import './assets/styles/main.scss'
import url from './services/url'
import store from './store'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

const FIVE_MB = 5 * 1024 * 1024
axios.defaults.maxContentLength = FIVE_MB
axios.defaults.maxBodyLength = FIVE_MB

smoothscroll.polyfill()

const rootContainer = document.getElementById('root')
render(
  <StrictMode>
    <StoreProvider store={store}>
      <Root />
    </StoreProvider>
  </StrictMode>,
  rootContainer,
)

const titleContainer = document.getElementsByTagName('title')[0]
render(
  <StrictMode>
    <Title />
  </StrictMode>,
  titleContainer,
)

if (process.env.REACT_APP_ENABLE_DATAGOG === 'true') {
  datadogRum.init({
    applicationId: 'd4d250f6-e28d-4f7a-b84f-a7acdd764198',
    clientToken: 'pub34fca3391e3569407a12c75ccf72453d',
    site: 'datadoghq.com',
    env: url.getCustomerEnvironment(),
    service: url.getCustomerSubdomainPart(),
    version: process.env.REACT_APP_VERSION,
    sampleRate: 100,
    trackInteractions: true,
  })
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => console.log('Custom SW registered:', reg))
      .catch((err) => console.error('SW registration failed:', err))
  })
}
